/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/web-app-bff-api-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/web-app-bff-api-client";
import type { CreateCompositionsDetailMutationRequest, CreateCompositionsDetailMutationResponse } from "../models/CreateCompositionsDetail";

export function getCreateCompositionsDetailUrl() {
  const res = { method: 'POST', url: `/compositions` as const }
  return res
}

/**
 * @summary Create a composition
 * {@link /compositions}
 */
export async function createCompositionsDetail(data: CreateCompositionsDetailMutationRequest, config: Partial<RequestConfig<CreateCompositionsDetailMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<CreateCompositionsDetailMutationResponse, ResponseErrorConfig<Error>, CreateCompositionsDetailMutationRequest>({ method : "POST", url : getCreateCompositionsDetailUrl().url.toString(), data : requestData, ... requestConfig })
  return res.data
}